// extracted by mini-css-extract-plugin
export var externalLink = "_6z-0";
export var internalLinkLabel = "_6z-1";